import { RootState, ComponentsState } from './types'
import { Module, GetterTree, ActionTree, MutationTree } from 'vuex'

const state: ComponentsState = {
  teachers: [],
  candidateStudents: [],
  filteredCandidateStudents: [],
  electedStudents: [],
}

const getters: GetterTree<ComponentsState, RootState> = {}

const actions: ActionTree<ComponentsState, RootState> = {}

const mutations: MutationTree<ComponentsState> = {
  setTeachers(state, payload: any) {
    state.teachers = payload
  },
  addTeacher(state, payload) {
    let teachers = state.teachers
    teachers.forEach((teacher, index) => {
      if (teacher.memberId === payload) {
        teacher.selected = true
      }
    })
    state.teachers = teachers
  },
  removeTeacher(state, payload) {
    let teachers = state.teachers
    teachers.forEach(teacher => {
      if (teacher.memberId === payload) {
        teacher.selected = false
      }
    })
    state.teachers = teachers
  },
  selectAllTeacher(state) {
    let teachers = state.teachers
    teachers.forEach(teacher => {
      teacher.selected = true
    })
    state.teachers = teachers
  },
  removeAllTeacher(state) {
    let teachers = state.teachers
    teachers.forEach(teacher => {
      teacher.selected = false
    })
    state.teachers = teachers
  },
}

const namespaced = true

export const components: Module<ComponentsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
